// Rutas del CRM derivadas del árbol del menú, sin importar ninguna sección:
// así se pueden probar sin montar la app.

/** Lo mínimo del árbol que hace falta para saber qué rutas existen. */
export interface NavShape {
  id: string;
  children?: NavShape[];
}

/**
 * Rutas que cambiaron de lugar en el menú → dónde viven ahora (relativas a
 * /crm). Hay enlaces guardados, correos y otras apps (Cobranza, Gastos) que
 * apuntan a las anteriores: se redirigen conservando `?query` y `#hash`.
 */
export const LEGACY_REDIRECTS: Record<string, string> = {
  // Cotizaciones y Facturas pasaron a ser subelementos de «Negocios».
  "negocios/cotizaciones": "negocios/negocios/cotizaciones",
  "negocios/facturas": "negocios/negocios/facturas",
};

/** Todas las rutas (relativas a /crm) que registra el menú de una funcionalidad. */
export function menuRoutePaths(slug: string, menu: NavShape[]): string[] {
  return menu.flatMap((item) =>
    item.children?.length
      ? [`${slug}/${item.id}`, ...item.children.map((c) => `${slug}/${item.id}/${c.id}`)]
      : [`${slug}/${item.id}`],
  );
}

/**
 * Redirecciones que se pueden registrar sin romper nada: su origen no es una
 * ruta viva (una redirección nunca pisa a una sección) y su destino sí existe.
 */
export function usableRedirects(livePaths: string[], redirects: Record<string, string> = LEGACY_REDIRECTS): [string, string][] {
  const live = new Set(livePaths);
  return Object.entries(redirects).filter(([from, to]) => !live.has(from) && live.has(to));
}
